import React, { useState, useEffect, useRef } from "react";
import Header from "../common/Header";
import Aside from "../common/Asside";
import * as echarts from "echarts";

function Hierarchy() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const chartRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await fetch("https://api2b.pro/api/hierarchy", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (data && chartRef.current) {
      const chart = echarts.init(chartRef.current);

      // Build vertical tree data
      const treeData = {
        name: data.affiliate?.username || "Affiliate",
        children: data.downlines?.map((dl) => ({
          name: dl.username,
        })) || [],
      };

      const option = {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        series: [
          {
            type: "tree",
            data: [treeData],
            top: "10%",
            left: "10%",
            bottom: "10%",
            right: "10%",
            orient: "vertical",
            symbolSize: 14,
            label: {
              position: "top",
              verticalAlign: "middle",
              align: "center",
              fontSize: 14,
            },
            leaves: {
              label: {
                position: "bottom",
                verticalAlign: "middle",
                align: "center",
              },
            },
            lineStyle: {
              color: "#999",
            },
            itemStyle: {
              borderColor: "red",
              borderWidth: 1,
            },
            expandAndCollapse: true,
            initialTreeDepth: -1,
            animationDuration: 750,
            animationDurationUpdate: 750,
          },
        ],
      };

      chart.setOption(option);
      return () => chart.dispose();
    }
  }, [data]);

  return (
    <div>
      <Header />
      <div className="container-flex">
        <Aside />
        <div className="main">
          <div className="page-content">
            <div className="main-inner">
              <div className="page-content-body" style={{ display: "block" }}>
                <form action="#" id="affiliateLinkForm">
                  <div className="section">
                    <div className="section-head">
                      <h2 className="title">Upline</h2>
                    </div>
                    <div className="section-body">
                      <div className="form-group form-column">
                        <div className="form-text">
                          {loading
                            ? "Loading..."
                            : data?.upline?.username || "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="section">
                    <div className="section-head">
                      <h2 className="title">Downline</h2>
                    </div>
                    <div className="section-body">
                      <div
                        ref={chartRef}
                        style={{
                          width: "100%",
                          height: "600px",
                          overflowX: "auto",
                          userSelect: "none",
                          position: "relative",
                        }}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <footer className="footer">
              Copyright © 2020. All rights Reserved
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hierarchy;
